let portalRoot: HTMLElement | null = null;

// WHY: не портировать в document.body — Next.js и Telegram SDK двигают его детей, WebKit бросает NotFoundError на
// removeChild при unmount
export function getPortalRoot(): HTMLElement {
  if (portalRoot && portalRoot.isConnected) return portalRoot;

  const existing = document.getElementById('shot-portal-root');
  if (existing instanceof HTMLElement) {
    portalRoot = existing;
    return portalRoot;
  }

  const el = document.createElement('div');
  el.id = 'shot-portal-root';
  document.body.appendChild(el);
  portalRoot = el;
  return portalRoot;
}
